// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AppsFunctionsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="AppsFunctionsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M2.07 9.317A1.45 1.45 0 0 1 1.5 8.68v2.466a1.32 1.32 0 0 0 .642 1.127L8.344 16v-2.869z" />
      <path d="m2.358 8.867.934.567 4.855-2.693V4l-5.77 3.324a.892.892 0 0 0-.019 1.543" />
      <path d="M17.642 8.867a.89.89 0 0 0-.019-1.543L11.853 4v2.74l4.855 2.694z" />
      <path d="M18.5 8.68a1.44 1.44 0 0 1-.568.637l-6.277 3.814V16l6.202-3.727a1.32 1.32 0 0 0 .642-1.127v-.717z" />
      <path d="M10.033 8.674c-.544 0-.984.428-.984.955 0 .528.44.956.984.956.543 0 .984-.428.984-.956 0-.527-.441-.955-.984-.955" />
      <path d="M7.478 8.674c-.544 0-.983.428-.983.955 0 .528.44.956.983.956s.984-.428.984-.956c0-.527-.44-.955-.984-.955" />
      <path d="M12.588 10.586c.542 0 .983-.428.983-.956 0-.527-.44-.955-.983-.955s-.984.428-.984.955c0 .528.44.956.984.956" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AppsFunctionsSignetIcon = /* @__PURE__ */ Object.assign(
  AppsFunctionsSignetIconComponent,
  { displayName: 'AppsFunctionsSignetIcon' },
);
